<script>
  export let name;
  export let langage;
  export let age;
  export let site;
</script>

<style>
  p {
    color: purple;
  }
</style>

<p>Salut, je suis {name}. Mon langage préféré est : {langage}. J'ai {age}ans. Mon site web : {site}</p>
